import { PATHS } from './paths';

const AUTH_REDIRECT_BLOCKLIST = [PATHS.login, PATHS.register, PATHS.verifyEmail, PATHS.forgotPassword, PATHS.resetPassword, PATHS.googleCallback];

export const isAuthPath = (path: string): boolean => AUTH_REDIRECT_BLOCKLIST.some((blocked) => path === blocked || path.startsWith(`${blocked}/`));

export const getSafeRedirectPath = (from?: string | null): string => {
  if (!from || !from.startsWith('/') || from.startsWith('//')) {
    return PATHS.dashboard;
  }

  const normalized = from.split(/[?#]/)[0] ?? from;
  if (isAuthPath(normalized)) {
    return PATHS.dashboard;
  }

  return from;
};
